import {
	NotificationChannelData,
	PushChannelsPerUser,
} from "@api-types/push-notifications/PushNotificationsDto";
import { UserTypes, getApplicationHeaders, httpClient } from "@utils";

export class PushNotificationsChannelSubscriptionsApiService {
	static get baseUrl(): string {
		return `${WEBPACK_BASE_ADDRESS}platform/mobile-push-channel-subscriptions`;
	}

	static getRequestHeaders = (
		activeAccount: UserTypes = UserTypes.PRIMARY
	) => {
		const appHeaders = getApplicationHeaders(activeAccount);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async fetchPushChannelsPerUser(
		userType: UserTypes = UserTypes.PRIMARY
	): Promise<PushChannelsPerUser> {
		return httpClient.get(
			`${this.baseUrl}/user-subscription?embed=MobilePushChannel&translate=true`,
			this.getRequestHeaders(userType),
			{ responseType: "json" }
		);
	}

	static async updateUserPushChannel(
		formData: NotificationChannelData,
		userType: UserTypes = UserTypes.PRIMARY
	) {
		return httpClient.post(
			`${this.baseUrl}/user-subscription/batch?embed=MobilePushChannel`,
			JSON.stringify(formData),
			this.getRequestHeaders(userType)
		);
	}
}
